export function clearUsernamePassword() {
  saveUsernamePassword(null, null);
}

export function saveUsernamePassword(username: string | null, password: string | null) {
  if (!window.platformSecureStore) {
    return;
  }
  const loginAutocompleteMessage = {
    username,
    password,
  };
  window.platformSecureStore.postMessage(JSON.stringify(loginAutocompleteMessage));
}
